import { LanguageLevel } from 'enums'
import { z } from 'zod'

const LanguageSchema = z.object({
  id: z.string().uuid().optional(),
  language: z.string()
})

export const LanguageLevelSchema = LanguageSchema.extend({
  languageLevel: z.nativeEnum(LanguageLevel)
})

export default LanguageSchema
